import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

/**
 * Handles authentication transitions to prevent 404 flash
 * This component wraps the NotFound page and checks if we're in a login transition
 */
export default function AuthTransitionHandler({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  const [, setLocation] = useLocation();
  
  // Check if we're in a login transition
  const isLoginTransition = sessionStorage.getItem('loginSuccess') === 'true';
  
  useEffect(() => {
    // If we have a login success flag and we're authenticated, redirect to home
    if (isLoginTransition && isAuthenticated && !isLoading) {
      // Clear the flag and redirect
      sessionStorage.removeItem('loginSuccess');
      setLocation('/');
    }
  }, [isLoginTransition, isAuthenticated, isLoading, setLocation]);
  
  // During login transition, show loading instead of 404
  if (isLoginTransition || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rh-helicopter-red mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your journey...</p>
        </div>
      </div>
    );
  }
  
  // Otherwise show the NotFound page
  return <>{children}</>;
}